import {showMagnetBtn} from '../common/help_functions';


export function initSearchBtn(element) {
    showMagnetBtn('.search-btn')
}